import styled from "@emotion/styled"
import { DataSourceTabLayout } from "../Wastewater/DataSourceTabLayout"
import { HawaiiCovidTimeSeries } from "./HawaiiCovidTimeSeries"
import { NsspTimeSeries } from "./NsspTimeSeries"

const GridContainer = styled("div")(() => ({
  display: "grid",
  gap: 16,
}))

export const ClinicalDataTab: React.FC = () => {
  return (
    <DataSourceTabLayout
      aboutContent={[
        "Clinical data provides measures of scale and severity of patient encounters with the health system for select pathogens. Sources may present data collected through syndromic, sentinel, and/or notifiable disease surveillance methods.",
        "This data should be interpreted with caution and in the context of other supporting sources, as encounter data may suffer from selection bias, poor ascertainment, and reporting lags or non-reporting. Surveillance methods and definitions may vary by location, disease, and source.",
      ]}
    >
      <GridContainer>
        <HawaiiCovidTimeSeries county="Honolulu" />
        <NsspTimeSeries county="Honolulu" />
      </GridContainer>
    </DataSourceTabLayout>
  )
}
